//GeneratorFlag:[NoChange]
import PersonAccess from './person-access';

export default {PersonAccess}
export{PersonAccess}